import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const VID_KEY = "tt_visitor_id";
const INSTALL_KEY = "tt_install_tracked";

function getVisitorId() {
  let v = localStorage.getItem(VID_KEY);
  if (!v) {
    v = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : String(Date.now()) + Math.random().toString(16).slice(2);
    localStorage.setItem(VID_KEY, v);
  }
  return v;
}

export default function AnalyticsTracker() {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;
    // Escludi le pagine di gestione admin dall'afflusso pubblico
    if (location.pathname.startsWith("/admin")) return;
    api.post("/analytics/visit", { path: location.pathname, visitor_id: getVisitorId() }).catch(() => {});
  }, [location.pathname]);

  useEffect(() => {
    const onInstalled = () => {
      localStorage.setItem(INSTALL_KEY, "1");
      api.post("/analytics/install", { visitor_id: getVisitorId() }).catch(() => {});
    };
    window.addEventListener("appinstalled", onInstalled);
    const standalone = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
    if (standalone && !localStorage.getItem(INSTALL_KEY)) {
      localStorage.setItem(INSTALL_KEY, "1");
      api.post("/analytics/install", { visitor_id: getVisitorId() }).catch(() => {});
    }
    return () => window.removeEventListener("appinstalled", onInstalled);
  }, []);

  return null;
}
